import * as React from "react";
import { barColor } from "../../../libs/commission_calculator_dashboard";

export const DonutChart = ({ percent }: { percent: number }) => {
  const color = barColor(percent);
  const deg = Math.round(360 * (percent / 100));
  let pieStyle = { clip: "rect(0, 1em, 1em, 0.5em)" };
  let rightSideStyle = {
    borderWidth: "0.1em",
    transform: "rotate(0deg)",
    borderColor: color,
  };
  let leftSideStyle = {
    borderWidth: "0.1em",
    transform: `rotate(${deg}deg)`,
    borderColor: color,
  };
  let shadowStyle = { borderWidth: "0.1em", borderColor: "#bdbdbd" };
  let numStyle = { color: color };

  if (percent > 50) {
    pieStyle.clip = "rect(auto, auto, auto, auto)";
    rightSideStyle.transform = "rotate(180deg)";
  }
  return (
    <div className="non-floating-percentage">
      <div className="donut-size">
        <div className="pie-wrapper">
          <span className="label">
            <span className="num" style={numStyle}>
              {percent}
            </span>
            <span style={numStyle}>%</span>
          </span>
          <div className="pie" style={pieStyle}>
            <div className="left-side half-circle" style={leftSideStyle} />
            <div className="right-side half-circle" style={rightSideStyle} />
          </div>
          <div className="shadow" style={shadowStyle} />
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/dashboard/DonutChart.tsx